import React, { Component } from 'react';
import PropTypes from 'prop-types';

import Avatar from './Avatar';

export default class MessagesSidebar extends Component {
  static propTypes = {
    currentUser: PropTypes.object.isRequired,
    communities: PropTypes.array.isRequired,
    selectedConnectionListId: PropTypes.string,
    onSelect: PropTypes.func.isRequired,
  };

  static defaultProps = {
    selectedConnectionListId: null,
  };

  handleClick(listId) {
    this.props.onSelect(listId);
  }

  renderItem(listId, type, avatar, name) {
    return (
      <div
        key={listId || 'me'}
        onClick={() => this.handleClick(listId)}
        className={`u-cursor-pointer u-p-4 u-border-b u-border-grey-light ${
          this.props.selectedConnectionListId === listId ? 'u-bg-white' : ''
        }`}>
        <Avatar
          src={avatar}
          name={name}
          type={type}
          className="u-w-8 u-h-8 u-rounded-sm u-float-left"
        />
      </div>
    );
  }

  render() {
    const { currentUser, communities } = this.props;

    return (
      <div className="u-flex-none u-bg-grey-lighter u-border-r u-border-grey-light u-flex u-flex-col">
        {this.renderItem(null, 'user', currentUser.avatar, currentUser.full_name)}

        {communities.map(community =>
          this.renderItem(community.slug, 'community', community.logo, community.name)
        )}
      </div>
    );
  }
}
